<div class="btn-loader-dots">
    <span></span>
    <span></span>
    <span></span>
</div>
